import Link, { type LinkProps } from 'next/link'
import clsx from 'clsx'
import type { ComponentProps } from 'react'
import { Pillow as BasePillow } from '@/components/Pillow/Pillow'
import { Text } from 'ui/src/components/Text/Text'
import { content, extendedLink, item } from './ProductItem.css'

function Item({ className, ...props }: ComponentProps<'div'>) {
  return <div className={clsx(item, className)} {...props} />
}

function Content({ className, ...props }: ComponentProps<'div'>) {
  return <div className={clsx(content, className)} {...props} />
}

function Pillow(props: Omit<ComponentProps<typeof BasePillow>, 'size'>) {
  return <BasePillow size="small" {...props} />
}

function Tagline(props: ComponentProps<typeof Text>) {
  return <Text size="xs" color="textSecondary" singleLine={true} {...props} />
}

function ExtendedLink({ className, ...props }: ComponentProps<typeof Link>) {
  return <Link className={clsx(extendedLink, className)} {...props} />
}

type TitleProps = LinkProps & { children: string; title?: string }

function TitleLink({ children, ...props }: TitleProps) {
  return (
    <ExtendedLink {...props}>
      <Text as="span">{children}</Text>
    </ExtendedLink>
  )
}

export const ProductItem = {
  Root: Item,
  Pillow,
  Content,
  TitleLink,
  Tagline,
} as const
